import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';

function NotificationPeople (){

  let result = reactLocalStorage.get('@result')
  if(result){ reactLocalStorage.remove('@result') };

  if(result === '200'){ toast.success('Pessoa Cadastrada!!'); }
  if(result === '201'){ toast.info('Pessoa Alterada!!'); }
  if(result === '202'){ toast.info('Status Alterado!!'); }
  if(result === '204'){ toast.error('Pessoa Excluída!!'); }

  return ( 
    <ToastContainer style={{ fontWeight: "bold" }}/>
  )
}

function NotificationUser (){

  let result = reactLocalStorage.get('@result')
  if(result){ reactLocalStorage.remove('@result') };

  if(result === '200'){ toast.success('Usuário Cadastrado!!'); }
  if(result === '201'){ toast.info('Usuário Alterado!!'); }
  if(result === '202'){ toast.info('Status Alterado!!'); }
  if(result === '203'){ toast.info('Senha Resetada!!'); }
  if(result === '204'){ toast.error('Usuário Excluído!!'); }

  return ( 
    <ToastContainer style={{ fontWeight: "bold" }}/>
  )
}

function NotificationAccount (){

  let result = reactLocalStorage.get('@result')
  if(result){ reactLocalStorage.remove('@result') };

  if(result === '200'){ toast.success('Conta Cadastrada!!'); }
  if(result === '201'){ toast.info('Conta Alterada!!'); }
  if(result === '202'){ toast.info('Status Alterado!!'); }
  if(result === '204'){ toast.error('Conta Excluída!!'); }

  return ( 
    <ToastContainer style={{ fontWeight: "bold" }}/>
  )
}

function NotificationExercise (){

  let result = reactLocalStorage.get('@result')
  if(result){ reactLocalStorage.remove('@result') };

  if(result === '200'){ toast.success('Exercício Cadastrado!!'); }
  if(result === '201'){ toast.info('Exercício Alterado!!'); }
  if(result === '202'){ toast.info('Status Alterado!!'); }
  if(result === '204'){ toast.error('Exercício Excluído!!'); }

  return ( 
    <ToastContainer style={{ fontWeight: "bold" }}/>
  )
}

function NotificationCategory (){

  let result = reactLocalStorage.get('@result')
  if(result){ reactLocalStorage.remove('@result') };

  if(result === '200'){ toast.success('Categoria Cadastrada!!'); }
  if(result === '201'){ toast.info('Categoria Alterada!!'); }
  if(result === '204'){ toast.error('Categoria Excluída!!'); }

  return ( 
    <ToastContainer style={{ fontWeight: "bold" }}/>
  )
}

function NotificationWorkout (){

  let result = reactLocalStorage.get('@result')
  if(result){ reactLocalStorage.remove('@result') };

  if(result === '200'){ toast.success('Microciclo Cadastrado!!'); }
  if(result === '201'){ toast.info('Treino Alterado!!'); }
  if(result === '202'){ toast.success('Ficha Cadastrada!!'); }
  if(result === '203'){ toast.success('Treino Cadastrado!!'); }
  if(result === '204'){ toast.error('Treino Excluído!!'); }
  if(result === '205'){ toast.error('Ficha Excluída!!'); }
  if(result === '206'){ toast.error('Microciclo Excluído!!'); }
  if(result === '207'){ toast.info('Ficha Alterada!!'); }

  return ( 
    <ToastContainer style={{ fontWeight: "bold" }}/>
  )
}


export { 
    NotificationPeople, 
    NotificationUser, 
    NotificationAccount, 
    NotificationExercise, 
    NotificationCategory,
    NotificationWorkout
  };